import { FC } from 'react';

import styles from './PhotoOverlay.scss';

const PhotoOverlay: FC = ({ children }) => {
    return <div className={styles.overlay}>{children}</div>;
};

export default PhotoOverlay;
